import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconShop = /*@__PURE__*/ proxyCustomElement(class CosmosIconShop extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '01ef2cb72cc046f3363ef74862704c9fc72e702a', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '93c16b3ecafd8f6811d8cf566c68b4843a50237d', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'd9b262d60c387176d8035f3b457a95e9cf00102c', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M17.86 7H6.13l-1-2.65A.49.49 0 0 0 4.71 4h-2.2a.5.5 0 0 0-.5.5V5a.5.5 0 0 0 .5.5H4l2.9 8.15a.5.5 0 0 0 .48.35h8.25a.5.5 0 0 0 .48-.35l2.23-6a.5.5 0 0 0-.48-.65m-3.64 11.75c.69 0 1.25-.56 1.25-1.25a1.24 1.24 0 0 0-1.25-1.25 1.25 1.25 0 1 0 0 2.5m-5.48 0a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5m-.65-6.25h6.83l1.54-4h-9.8z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-shop", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-shop"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-shop":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconShop);
            }
            break;
    } });
}

export { CosmosIconShop as C, defineCustomElement as d };
